<template>
    <div id="entry">
        <login-box :showLogin="showLogin" @closeLogin="closeBox" ref="login"></login-box>
        <div class="common-header container clearfix" @click="goHome">
            <div class="logo"></div>
            <div title="" class="title">{{ columnInfo.title }}机考模拟系统</div>
        </div>
        <div class="main">
            <section class="courseList">

                <div class="content">
                    <h2>{{ columnInfo.title }}机考模拟系统</h2>
                    <div class="tip">
                        <div class="tc">请您点击下列考试科目名称，进入机考模拟系统界面！推荐使用ie9以上浏览器</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in classData" :key="index" :title="item.title"
                                @click="mycourse(item)" v-if="index < 4">
                                <a href="javascript:void(0);" target="_self">{{ item.title }}</a>
                            </li>
                        </ul>
                    </div>
                    <h2 style="margin-top: 50px;">{{ columnInfo.title }}面试系统</h2>
                    <div class="tip">
                        <div class="tc">仅模拟测试流程，无实际试题</div>
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in classData" :key="index" :title="item.title"
                                @click="mycourse(item)" v-if="index == 4">
                                <a href="javascript:void(0);" target="_self">{{ item.title }}</a>
                            </li>
                        </ul>
                    </div>

                </div>

            </section>
        </div>
        <div class="footer"></div>

        <el-dialog title="各地区面试系统列表" custom-class="diags" :visible.sync="dialogOutVisible" :close-on-click-modal="false"
            width="55%">
            <span class="msBox msBold">请使用以下准考证号登录本机考练习系统，进行机考模拟练习：</span>
            <span class="msBox msBold">中文练习：1234</span>
            <span class="msBox msBold">外语练习：2234</span>
            <span class="msBox msBold">面试练习盘地址（复制链接到电脑浏览器上打开）：</span>
            <span class="msBox msBold">为保证最佳的机考模拟体验，请使用谷歌、火狐、Edge87及以上浏览器打开</span>
            <span class="msBox">北京：<a href="https://demo.joytest.org/demo/t/dy2023fgrtktbjztaxdh01/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023fgrtktbjztaxdh01/1</a></span>
            <span class="msBox">山西：<a href="https://demo.joytest.org/demo/t/dy2023sx16/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023sx16/1</a></span>
            <span class="msBox">内蒙古：<a href="https://demo.joytest.org/demo/t/dy2023nm04/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023nm04/1</a></span>
            <span class="msBox">上海：<a href="https://c.yj.live/99741197"
                    target="_blank">https://c.yj.live/99741197（请使用报名时注册的身份证件登录）</a></span>
            <span class="msBox">福建：<a href="https://demo.joytest.org/demo/t/dy2024ufxxenfjqobwrk17/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024ufxxenfjqobwrk17/1</a></span>
            <span class="msBox">安徽：<a href="https://demo.joytest.org/demo/t/dy2023hkwcysahuhsrdy15/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023hkwcysahuhsrdy15/1</a></span>
            <span class="msBox">江西：<a href="https://demo.joytest.org/demo/t/dy2024wucseejxnperti0006505/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024wucseejxnperti0006505/1</a></span>
            <span class="msBox">山东：<a href="https://demo.joytest.org/demo/t/dy2023wcwxcksdyeamjc06/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023wcwxcksdyeamjc06/1</a></span>
            <span class="msBox">广东：<a href="https://demo.joytest.org/demo/t/dy2024clbmnfgdpuzwou18/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024clbmnfgdpuzwou18/1</a></span>
            <span class="msBox">广西：<a href="https://demo.joytest.org/demo/t/dy2024obzepmgxzojffv05/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024obzepmgxzojffv05/1</a></span>
            <span class="msBox">四川：<a href="https://demo.joytest.org/demo/t/dy2024kktpykscinpjte13/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024kktpykscinpjte13/1</a></span>
            <span class="msBox">重庆：<a href="https://demo.joytest.org/demo/t/dy2023cq20/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023cq20/1</a></span>
            <span class="msBox">海南：<a href="https://demo.joytest.org/demo/t/dy2023hn03/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023hn03/1</a></span>
            <span class="msBox">陕西：<a href="https://demo.joytest.org/demo/t/dy2023sx12/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023sx12/1</a></span>
            <span class="msBox">青海：<a href="https://demo.joytest.org/demo/t/dy2023qh07/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023qh07/1</a></span>
            <span class="msBox">甘肃：<a href="https://demo.joytest.org/demo/t/dy2023gs02/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023gs02/1</a></span>
            <span class="msBox">新疆：<a href="https://demo.joytest.org/demo/t/dy2023veujswxjnzjtrx11/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023veujswxjnzjtrx11/1</a></span>
            <span class="msBox">兵团：<a href="https://demo.joytest.org/demo/t/dy2023spjtjdxjbtcudbjt21/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2023spjtjdxjbtcudbjt21/1</a></span>
            <span class="msBox">湖北：<a href="https://demo.joytest.org/demo/t/dy2024nfpqwdhbhshepj0014253/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024nfpqwdhbhshepj0014253/1</a></span>
            <span class="msBox">黑龙江：<a href="https://demo.joytest.org/demo/t/dy2024donctnhljgcwieh09/1"
                    target="_blank">https://demo.joytest.org/demo/t/dy2024donctnhljgcwieh09/1</a></span>


        </el-dialog>

        <!-- 选择试卷 -->
        <el-dialog title="模考试卷列表" custom-class="diags" :visible.sync="dialogPaperVisible" :close-on-click-modal="false"
            width="55%">
            <div class="paperBox">
                <div class="paperList" v-for="(item, index) in paperData" :key="index">
                    <div class="paperTitle">{{ index + 1 }}、{{ item.title }}</div>
                    <div class="paperButton" @click="goLogin(item.id)">进入机考</div>
                </div>
            </div>
        </el-dialog>

    </div>

</template>
<script>
import LoginBox from "@/components/LoginBox";
export default {
    components: {
        LoginBox,
    },
    data() {
        return {
            showLogin: false,
            dialogOutVisible: false,
            dialogPaperVisible: false,
            column_id: 0,
            subject_id: 0,
            columnInfo: [],
            classData: [],
            paperData: [],
        };
    },
    mounted: function () {
        sessionStorage.removeItem("access-mecoPapers");
        var query = this.$route.query;
        if (query.column_id) {
            this.column_id = query.column_id;
            this.getList();
        }
        if (query.subject_id) {
            this.subject_id = query.subject_id;
        }

    },
    methods: {
        //判断是否登录
        IsUsersLogin() {
            let token = sessionStorage.getItem("access-token");
            console.log(token);
            if (token) {
                return true;
            } else {
                this.showLogin = true;
                this.$refs.login.getMiQrCode();
                return false;
            }
        },

        closeBox(e) {
            this.showLogin = false;
        },

        goHome() {
            this.$confirm('确认要退出考试吗？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push("/web/index");
            });
        },

        getList() {
            let that = this;
            let formData = {};
            formData.column_id = that.column_id;
            that.axios.post("/getColumnInfo", formData).then((res) => {
                if (res) {
                    that.classData = res.data.subject;
                    that.columnInfo = res.data;
                    sessionStorage.setItem("access-mecoName", res.data.title);
                }
            });
        },

        mycourse(e) {
            if (this.IsUsersLogin()) {
                sessionStorage.setItem("access-mecoId", e.id);
                sessionStorage.setItem("access-mecoTitle", e.title);
                if (e.id == 260) {
                    this.dialogOutVisible = true;
                } else {
                    this.dialogPaperVisible = true;
                    let formData = {};
                    formData.subject_id = e.id;
                    this.axios.post("/getExamPapers", formData).then((res) => {
                        if (res) {
                            this.paperData = res.data;
                        }
                    });
                }
            }
        },

        goLogin(e) {
            this.$router.push({
                path: "/guide/login",
                query: {
                    paper_id: e,
                },
            });
        }
    },
};
</script>

<style>
@import "../../../public/css/meco.css";

.paperBox {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.paperBox .paperList {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px dashed #ccc;
    align-items: center;
    padding: 10px 0;
}

.el-dialog__body {
    padding: 5px 20px;
}

.paperBox .paperList .paperTitle {
    width: 80%;
}

.paperBox .paperList .paperButton {
    width: 100px;
    text-align: center;
    border: 2px solid #409eff;
    height: 36px;
    line-height: 36px;
    border-radius: 6px;
    color: #409eff;
    cursor: pointer;
    font-size: 14px;
}

.diags .el-dialog__body {
    display: flex;
    flex-direction: column;
    height: 500px;
    overflow: scroll;
}

.msBox {
    width: 100%;
    line-height: 27px;
    font-size: 16px;
}

.msBold {
    font-weight: bold;
}
</style>